import React from "react";
import HyroStackedBarChart from "@hyro-components/hyro-stacked-bar-chart/HyroStackedBarChart";
import ChannelSkillsTooltipContent from "./ChannelSkillsTooltipContent";
import { CHANNEL_META, CHANNEL_ORDER } from "./SubscriptionTab.consts";

export const USAGE_CHART_TEST_ID = "usage-over-time-chart";

// Monthly engaged interactions stacked by channel (Figma "Usage over time"); rows come from buildChartData.
const UsageOverTimeChart = ({ data = [], loading = false }) => (
  <HyroStackedBarChart
    data={data}
    keys={CHANNEL_ORDER}
    getColor={(channelType) => CHANNEL_META[channelType].color}
    loading={loading}
    testId={USAGE_CHART_TEST_ID}
    renderTooltip={({ key: channelType, row }) => (
      <ChannelSkillsTooltipContent
        channelType={channelType}
        engaged={row?.byChannel?.[channelType]?.engaged ?? 0}
        skills={row?.byChannel?.[channelType]?.skills ?? []}
      />
    )}
  />
);

export default UsageOverTimeChart;
